module.exports = __webpack_public_path__ + "img/owl.b92e108.png";